import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { api } from "@/lib/api";

const KEY = "sarvaseva_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch { setShow(true); }
  }, []);

  const choose = async (level) => {
    const record = { level, timestamp: new Date().toISOString(), version: "1.0" };
    try { localStorage.setItem(KEY, JSON.stringify(record)); } catch {}
    setShow(false);
    try {
      await api.post("/consent", {
        consent_type: "cookies",
        level,
        user_agent: navigator.userAgent,
        version: "1.0",
      });
    } catch { /* non-blocking */ }
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t border-[#E4E7EC]"
      style={{ boxShadow: "0 -4px 20px rgba(0,0,0,0.1)" }}
      data-testid="cookie-consent-banner"
      role="dialog"
      aria-label="Cookie consent">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <p className="flex items-start gap-2 text-sm text-[#374151] leading-relaxed flex-1">
          <Cookie size={18} className="mt-0.5 shrink-0 text-[#D97706]" />
          <span>We use cookies to improve your experience. We process health data under strict privacy controls. See our{" "}
            <Link to="/privacy" className="text-[#0D5C75] underline font-medium">Privacy Policy</Link>.</span>
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button onClick={() => choose("essential")} data-testid="cookie-essential-btn"
            className="rounded-xl border-2 border-[#0D5C75] px-5 py-2 text-sm font-semibold text-[#0D5C75] hover:bg-[#0D5C75] hover:text-white transition-all duration-300">
            Essential Only
          </button>
          <button onClick={() => choose("all")} data-testid="cookie-accept-all-btn"
            className="rounded-xl px-5 py-2 text-sm font-semibold text-white bg-gradient-to-br from-[#0D5C75] to-[#2A9D8F] shadow-[0_4px_14px_rgba(13,92,117,0.28)] hover:-translate-y-0.5 transition-all duration-300">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
